module.exports = __webpack_public_path__ + "components/page-footer/static/snow-forecast__logo--white-223c4cd03b0d9d9b353ab3bc86c9be7a.png";